export default "__VITE_ASSET__e18b2bef__"